import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { DASHBOARD_BILL_VIEW, DASHBOARD_IRD_VIEW } from '../../../constants/DashboardConst';
import { selectedHotelSelector } from '../../property/propertySlice';
import {
  dashboardFnbIrdModeSelector,
  dashboardViewStateSelector,
  setDashboardViewState,
} from '../DashboardSlice';
import DashboardFnbList from './dashboard-fnb-list/DashboardFnbList';
import DashboardBillView from './dashboard-fnb-view/DashboardBillView';
import DashboardFnbView from './dashboard-fnb-view/DashboardFnbView';
import DashboardIRDView from './dashboard-ird-view/DashboardIRDView';
import { decryptLocalStorage } from '../../../utils/authUtils';

const DashboardFnb = (props) => {
  const { permissions, showLoader = () => {} } = props;
  const selectedHotel = useSelector(selectedHotelSelector);
  const dashboardViewState = useSelector(dashboardViewStateSelector);
  const [page, setPage] = useState(0);
  const [billMode, setBillMode] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const dashboardIrdMode = useSelector(dashboardFnbIrdModeSelector);
  const currentFilterFromLocation = location?.state?.status;

  useEffect(() => {
    let isSelectedHotel = selectedHotel || decryptLocalStorage('hotelId');
    if (!isSelectedHotel) {
      history.push('/properties');
    }
  }, [history, selectedHotel]);

  const onViewToggle = (type, status, obj, billMode) => {
    dispatch(setDashboardViewState({ type: type, status: status, obj: obj }));
    if (billMode) {
      setBillMode(true);
    }
  };

  const switchViewContent = (inpState) => {
    switch (inpState.type) {
      case DASHBOARD_IRD_VIEW:
        return dashboardIrdMode ? (
          <DashboardIRDView
            obj={dashboardViewState.obj}
            onViewToggle={onViewToggle}
            hotelId={selectedHotel}
            showLoader={showLoader}
            permissions={permissions}
          />
        ) : (
          <DashboardFnbView
            obj={dashboardViewState.obj}
            onViewToggle={onViewToggle}
            hotelId={selectedHotel}
            showLoader={showLoader}
          />
        );
      case DASHBOARD_BILL_VIEW:
        return (
          <DashboardBillView
            obj={dashboardViewState.obj}
            onViewToggle={onViewToggle}
            hotelId={selectedHotel}
            showLoader={showLoader}
          ></DashboardBillView>
        );
      default:
        break;
    }
  };

  return (
    <>
      {dashboardViewState.status && <>{switchViewContent(dashboardViewState)}</>}
      {!dashboardViewState.status && (
        <>
          <DashboardFnbList
            onViewToggle={onViewToggle}
            hotelId={selectedHotel}
            permissions={permissions}
            onsetPage={(e) => setPage(e)}
            page={page}
            onsetRowsPerPage={(e) => setRowsPerPage(e)}
            rowsPerPage={rowsPerPage}
            billMode={billMode}
            currentFilterFromLocation={currentFilterFromLocation}
            showLoader={showLoader}
          />
        </>
      )}
    </>
  );
};

export default DashboardFnb;
